import React from 'react';
import { addGlobalFill } from 'foremanReact/components/common/Fill/GlobalFill';
import RexInterface from '../components/RegistrationExtension/RexInterface';

export default () =>
  addGlobalFill(
    'registrationAdvanced',
    'foreman-remote-exectuion-rex-interface',
    <RexInterface key="registration-rex-interface" />,
    100
  );



// WEBPACK FOOTER //
// ./vendor/ruby/2.5.0/gems/foreman_remote_execution-4.5.6/webpack/react_app/extend/fillregistrationAdvanced.js